interface UserIconProps {
  color?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function UserIcon({ width = 24, height = 23, className = 'text-current', color = 'white' }: UserIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.0889 11.6454C19.114 10.6203 20.7757 10.6203 21.8008 11.6454L22.3545 12.1991L22.5347 12.3983C23.3197 13.3606 23.3197 14.7494 22.5347 15.7118L22.3545 15.911L21.0186 17.2455C21.0148 17.2494 21.0122 17.2548 21.0083 17.2586C21.0044 17.2626 20.9991 17.2651 20.9952 17.2689L17.6055 20.66C16.9977 21.2678 16.2151 21.6714 15.3672 21.8128L13.5889 22.1087C12.5906 22.2751 11.7248 21.4093 11.8912 20.411L12.1871 18.6327C12.3285 17.7849 12.7321 17.0022 13.3399 16.3944L18.0889 11.6454ZM14.9307 17.9852C14.6544 18.2615 14.4705 18.6178 14.4063 19.0033L14.2876 19.7108L14.9966 19.5936C15.3821 19.5294 15.7384 19.3455 16.0147 19.0692L18.6206 16.4618L17.5367 15.3778L14.9307 17.9852ZM20.21 13.2362C20.0635 13.0898 19.8262 13.0898 19.6797 13.2362L19.1289 13.787L20.2129 14.871L20.7637 14.3202C20.8919 14.192 20.9082 13.9941 20.8121 13.8485L20.7637 13.7899L20.21 13.2362Z"
        fill={color}
      />
      <path
        d="M11.6724 12.875L11.7866 12.8809C12.354 12.9383 12.7974 13.4174 12.7974 14C12.7974 14.5826 12.354 15.0617 11.7866 15.1191L11.6724 15.125H7.14307C5.01417 15.125 3.27616 16.781 3.13818 18.875H9.05762L9.17334 18.8809C9.7406 18.9385 10.1826 19.4175 10.1826 20C10.1826 20.5825 9.7406 21.0615 9.17334 21.1191L9.05762 21.125H2.85693C1.76239 21.1249 0.875113 20.2376 0.875 19.1431C0.875 15.6814 3.68142 12.875 7.14307 12.875H11.6724ZM13.1255 6.24951C13.1252 4.52385 11.7252 3.125 9.99951 3.125C8.27401 3.12526 6.87526 4.52401 6.875 6.24951C6.875 7.97524 8.27385 9.37522 9.99951 9.37549C11.7254 9.37549 13.1255 7.9754 13.1255 6.24951ZM15.3755 6.24951C15.3755 9.21804 12.968 11.6255 9.99951 11.6255C7.03121 11.6252 4.625 9.21788 4.625 6.24951C4.62526 3.28137 7.03137 0.875264 9.99951 0.875C12.9679 0.875 15.3752 3.28121 15.3755 6.24951Z"
        fill={color}
      />
    </svg>
  );
}
